/**
 * Spec 195 — what a SAVED schedule's edit dialog may offer, read off the schedule row.
 *
 * Pure, no React.
 */

/**
 * Can this schedule's runs roll their dates forward? Only a GENERIC schedule's can: the
 * runner re-resolves a date preset only on the generic path (`buildScheduleJob`, cb-api
 * `jobs/runner.js`), whose stored filters are an array the token rides on. Every other
 * kind stores its report's own request, which no preset reaches — so a roll-forward
 * choice offered there is saved, or ignored, and changes nothing.
 *
 * An absent `kind` (an older payload) keeps today's behaviour rather than guessing, the
 * same rule `attachSupported` follows in the edit dialog.
 */
export const rollsForward = (schedule) => schedule?.kind == null || schedule.kind === 'generic'

/** The catalog report number to print as "Report #N", or null when the id is none (`exago/<guid>`). */
export const reportNumberOf = (schedule) => {
  const id = schedule?.reportId
  return id != null && /^\d+$/.test(String(id)) ? String(id) : null
}
